import {
  NarvarStatus,
  NarvarStatusCode,
} from '../../../../../__generated__/loma';
import mustache from 'mustache';

import {
  StepperInfo,
  getSteps,
  PREVIEW_LOCAL_DELIVERY_DELIVERED,
  PREVIEW_LOCAL_DELIVERY_EXCEPTION,
  PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY,
  PREVIEW_LOCAL_DELIVERY_ORDER_PLACED,
  PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS,
  PREVIEW_HPU_PICKED_UP,
  PREVIEW_HPU_PICKUP_IN_PROGRESS,
  PREVIEW_HPU_SCHEDULED,
  PREVIEW_MAPVIEW_ON_ITS_WAY,
  PREVIEW_MAPVIEW_DELIVERED,
} from './constants';

export const getStepperInfo = (
  status: NarvarStatus,
  statusCode: NarvarStatusCode,
): StepperInfo => {
  const STEPS = getSteps(statusCode);
  switch (status) {
    case 'LDORDERPLACED':
      return STEPS[PREVIEW_LOCAL_DELIVERY_ORDER_PLACED];
    case 'LDPICKUPINPROGRESS':
      return STEPS[PREVIEW_LOCAL_DELIVERY_PICKUP_IN_PROGRESS];
    case 'LDONITSWAY':
      return STEPS[PREVIEW_LOCAL_DELIVERY_ON_ITS_WAY];
    case 'LDDELIVERED':
      return STEPS[PREVIEW_LOCAL_DELIVERY_DELIVERED];
    case 'HPUSCHEDULED':
      return STEPS[PREVIEW_HPU_SCHEDULED];
    case 'HPUPICKEDUP':
      return STEPS[PREVIEW_HPU_PICKED_UP];
    case 'HPUPICKUPINPROGRESS':
      return STEPS[PREVIEW_HPU_PICKUP_IN_PROGRESS];
    case 'MVINTRANSIT':
      return STEPS[PREVIEW_MAPVIEW_ON_ITS_WAY];
    case 'MVDELIVERED':
      return STEPS[PREVIEW_MAPVIEW_DELIVERED];
    case 'LDEXCEPTION':
    case 'HPUEXCEPTION':
    case 'MVEXCEPTION':
    default:
      return STEPS[PREVIEW_LOCAL_DELIVERY_EXCEPTION];
  }
};

export const renderTemplate = (
  template: string,
  view: Record<string, unknown>,
): ReturnType<typeof mustache.render> =>
  mustache.render(template, view, undefined, {
    escape: (x: string): string => x,
  });

export const addAlpha = (color: string, opacity: number) => {
  if (opacity < 0 || opacity > 1) {
    return color;
  }
  return (
    color +
    Math.round(opacity * 255)
      .toString(16)
      .toUpperCase()
  );
};
